<template>
  <pagefra>
    <div class="alarmPushRecord container">
      <panel type="toolbar">
        <div class="toolbar">
          <el-form
            class="toolbar-form"
            :inline="true"
            v-model="form"
            label-width
          >
            <el-form-item :label="$l('消息类型')">
              <el-select
                v-model="form.msgType"
                :placeholder="$l('消息类型')"
                @change="msgTypeChange"
              >
                <el-option :label="$l('故障报警')" value="0"></el-option>
                <el-option :label="$l('保养计划')" value="1"></el-option>
                <el-option :label="$l('年检计划')" value="2"></el-option>
                <el-option :label="$l('公告通知')" value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$l('接收人')">
              <el-input
                v-model="form.receiver"
                :placeholder="$l('接收人')"
                style="width: 120px"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('故障设备')" v-if="form.msgType == '0'">
              <el-input
                v-model="form.jobNum"
                :placeholder="$l('故障设备')"
                style="width: 120px"
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$l('电梯工号')"
              v-else-if="form.msgType == '1' || form.msgType == '2'"
            >
              <el-input
                v-model="form.jobNum"
                :placeholder="$l('电梯工号')"
                style="width: 120px"
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$l('发送状态') + 1"
              v-if="form.msgType == '0'"
            >
              <el-select
                v-model="form.sendStatus"
                :placeholder="$l('发送状态') + 1"
              >
                <el-option :label="$l('发送状态') + 1" value="-1"></el-option>
                <el-option :label="$l('成功')" value="1"></el-option>
                <el-option :label="$l('失败')" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$l('发送状态')" v-else>
              <el-select
                v-model="form.sendStatus"
                :placeholder="$l('发送状态')"
              >
                <el-option :label="$l('发送状态')" value="-1"></el-option>
                <el-option :label="$l('成功')" value="1"></el-option>
                <el-option :label="$l('失败')" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :label="$l('发送状态') + 2"
              v-if="form.msgType == '0'"
            >
              <el-select
                v-model="form.finishSendStatus"
                :placeholder="$l('发送状态') + 2"
              >
                <el-option :label="$l('发送状态') + 2" value="-1"></el-option>
                <el-option :label="$l('成功')" value="1"></el-option>
                <el-option :label="$l('失败')" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$l('时间')">
              <el-date-picker
                v-model="timeValues"
                type="datetimerange"
                :range-separator="$l('至')"
                :start-placeholder="$l('开始时间')"
                :end-placeholder="$l('结束时间')"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                circle
                @click="search"
              ></el-button>
            </el-form-item>
          </el-form>
          <div class="toolbar-btn">
            <el-button
              round
              icon="el-icon-download"
              @click="exportRecord"
              v-if="hasPermission('导出')"
              >{{ $l("导出") }}
            </el-button>
          </div>
        </div>
      </panel>
      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="filterTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            height="100%"
            v-loading.lock="loading"
            :data="tableData"
            style="width: 100%; z-index: 1000"
          >
            <el-table-column
              type="index"
              :label="$l('序号')"
              min-width="80"
              align="center"
              key="0"
            ></el-table-column>
            <el-table-column
              :label="$l('接收人')"
              prop="receiver"
              align="center"
              min-width="100"
              key="1"
            ></el-table-column>
            <el-table-column
              :label="$l('微信用户标识')"
              prop="openId"
              align="center"
              min-width="260"
              key="2"
            ></el-table-column>
            <el-table-column
              v-if="form.msgType !== '3'"
              :label="form.msgType === '0' ? $l('故障设备') : $l('电梯工号')"
              prop="jobNum"
              align="center"
              min-width="100"
              key="3"
            ></el-table-column>
            <el-table-column
              :label="$l('故障类型')"
              prop="description"
              align="center"
              min-width="100"
              v-if="form.msgType === '0'"
              key="4"
            >
              <template slot-scope="scope">
                <span :title="scope.row.description">{{
                  scope.row.description && scope.row.description.length > 20
                    ? scope.row.description.substring(0, 20) + "..."
                    : scope.row.description
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('故障时间')"
              prop="alarmDate"
              align="center"
              min-width="200"
              key="5"
              v-if="form.msgType === '0'"
            ></el-table-column>
            <el-table-column
              :label="$l('保养开始时间')"
              prop="typeDate"
              align="center"
              min-width="200"
              key="6"
              v-else-if="form.msgType === '1'"
            ></el-table-column>
            <el-table-column
              :label="$l('年检时间')"
              prop="typeDate"
              align="center"
              min-width="200"
              key="7"
              v-else-if="form.msgType === '2'"
            ></el-table-column>
            <el-table-column
              :label="$l('公告开始时间')"
              prop="typeDate"
              align="center"
              min-width="200"
              key="8"
              v-else-if="form.msgType === '3'"
            ></el-table-column>
            <el-table-column
              :label="
                form.msgType === '0' ? $l('发送状态') + 1 : $l('发送状态')
              "
              prop="sendStatus"
              align="center"
              min-width="80"
              :formatter="sendStatusFormatter"
              key="9"
            ></el-table-column>
            <el-table-column
              v-if="form.msgType === '0'"
              :label="$l('故障恢复时间')"
              prop="finishDate"
              align="center"
              min-width="200"
              key="10"
            ></el-table-column>
            <el-table-column
              v-if="form.msgType === '0'"
              :label="$l('发送状态') + 2"
              prop="finishSendStatus"
              align="center"
              min-width="80"
              :formatter="sendFinishStatusFormatter"
              key="11"
            ></el-table-column>
            <el-table-column
              :label="$l('发送时间')"
              prop="sendDate"
              align="center"
              min-width="200"
              key="12"
              sortable
            ></el-table-column>
          </el-table>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>
    </div>
  </pagefra>
</template>

<script>
// @ is an alias to /src
import panel from "@/components/panel.vue";
import global from "@/mixins/global.js";
export default {
  name: "alarmPushRecord",
  mixins: [global],
  components: {
    panel,
  },
  props: {
    loaded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        receiver: "",
        sendStatus: "",
        finishSendStatus: "",
        jobNum: "",
        startDate: "",
        endDate: "",
        msgType: "0",
      },
      timeValues: [],
      tableData: [],
      selectedList: [],
      loading: false,
    };
  },
  mounted() {
    this.timeValues = this.$common.getTimeRange(7);
    if (this.loaded) {
      this.initData();
    }
  },
  methods: {
    handlePageSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.initData();
    },
    handleCurrentPageChange(val) {
      this.pageConfig.currentPage = val;
      this.initData();
    },
    search() {
      this.pageConfig.currentPage = 1;
      this.initData();
    },
    initData() {
      const dataListCacheKey = this.$options.name + "_data_list";
      const dataTotalCacheKey = this.$options.name + "_data_total";
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(dataListCacheKey);
        if (json) {
          this.tableData = JSON.parse(json);
          this.pageConfig.total = parseInt(
            sessionStorage.getItem(dataTotalCacheKey)
          );
          sessionStorage.removeItem(dataTotalCacheKey);
          sessionStorage.removeItem(dataListCacheKey);
          return;
        }
      }
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      this.tableData = [];
      if (this.timeValues && this.timeValues.length == 2) {
        this.form.startDate = this.$common.formatDateTime(this.timeValues[0]);
        this.form.endDate = this.$common.formatDateTime(this.timeValues[1]);
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
      this.loading = true;
      this.$http
        .get(
          this.form.msgType == "0"
            ? this.$apiConfig.search_alarm_push_record_url
            : this.$apiConfig.search_wx_push_record_url,
          {
            params: this.form,
          }
        )
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            let temp = result.data.result;
            this.tableData = temp;
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(dataListCacheKey)
            ) {
              sessionStorage.setItem(dataTotalCacheKey, this.pageConfig.total);
              sessionStorage.setItem(
                dataListCacheKey,
                JSON.stringify(this.tableData)
              );
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    sendStatusFormatter(row) {
      if (row.sendStatus == 1) {
        return "成功";
      } else {
        return "失败";
      }
    },
    sendFinishStatusFormatter(row) {
      if (row.finishSendStatus == 1) {
        return "成功";
      } else if (row.finishSendStatus == 0) {
        return "失败";
      } else {
        return "";
      }
    },
    exportRecord() {
      if (this.timeValues && this.timeValues.length == 2) {
        this.form.startDate = this.$common.formatDateTime(this.timeValues[0]);
        this.form.endDate = this.$common.formatDateTime(this.timeValues[1]);
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
      this.fullLoading = true;
      let name =
        this.form.msgType == "0"
          ? "微信报警推送管理表"
          : this.form.msgType == "1"
          ? "保养计划推送记录表"
          : this.form.msgType == "2"
          ? "年检计划推送记录表"
          : "公告推送记录表";
      let filename =
        name + "_" + this.$common.formatCurrentDateTime(false) + ".xlsx";
      this.$http({
        url:
          this.form.msgType == "0"
            ? this.$apiConfig.export_alarm_push_url
            : this.$apiConfig.export_wx_push_url,
        method: "post",
        responseType: "blob",
        data: this.form,
      })
        .then((response) => {
          this.fullLoading = false;
          const status = response.status;
          if (status != 200) {
            this.message(
              1,
              status == 201
                ? "导出失败"
                : status == 202
                ? "没有数据"
                : "数据量过大"
            );
            return;
          }
          const data = response.data;
          var blob = new Blob([data]);
          //判断是不是ie的浏览器
          if (!!window.ActiveXObject || "ActiveXObject" in window) {
            window.navigator.msSaveOrOpenBlob(blob, filename);
          } else {
            var url = window.URL.createObjectURL(blob);
            var aLink = document.createElement("a");
            aLink.style.display = "none";
            aLink.download = filename;
            aLink.href = url;
            document.body.appendChild(aLink);
            aLink.click();
            document.body.removeChild(aLink); // 下载完成移除元素
            window.URL.revokeObjectURL(url); // 释放掉blob对象
          }
        })
        .catch((error) => {
          this.fullLoading = false;
          this.errorMessage(0);
          this.$sentry.captureException(error);
        });
    },
    msgTypeChange(val) {
      this.pageConfig.currentPage = 1;
      this.initData();
    },
  },
};
</script>
<style lang="scss" scoped>
.alarmPushRecord {
  em {
    color: red;
  }
}
</style>
